import script from "./AddCompanyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCompanyModal.vue?vue&type=script&setup=true&lang=js"

import "./AddCompanyModal.vue?vue&type=style&index=0&id=29050256&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29050256"]])

export default __exports__